import React, { Component } from "react";
import "./style.css";
class SchoolBrief extends Component {
  render() {
    const { visible, data } = this.props;
    return data === null ? (
      ""
    ) : (
      <div style={{ display: visible === true ? "block" : "none",paddingLeft:20,paddingRight:20 }}>
        <div dangerouslySetInnerHTML={{ __html: data.schoolIntro }}></div>
      </div>
    );
  }
}

export default SchoolBrief;



// WEBPACK FOOTER //
// ./src/components/School/SchoolDetail/SchoolDetailDown/components/SchoolBrief/index.js